"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isBefore = function isBefore(date1, date2) {
  return (0, _dayjs["default"])(date1).isBefore(date2);
};

var _default = isBefore;
exports["default"] = _default;